import React, { Component } from 'react';
import { motion } from 'framer-motion';
import { PenTool, Settings, Microscope, BoxIcon } from 'lucide-react';
const steps = [{
  id: 1,
  title: 'Design Consultation',
  description: 'We start by understanding your specific requirements for medical or packaging components. Our team reviews your CAD files for manufacturability (DFM) to ensure efficiency and precision.',
  icon: PenTool
}, {
  id: 2,
  title: 'Prototyping & Tooling',
  description: 'Rapid iteration and mold creation. We use high-grade steel and precise machining to create molds that deliver consistent, defect-free parts for validation.',
  icon: Settings
}, {
  id: 3,
  title: 'Precision Production',
  description: 'Using state-of-the-art electric injection molding machines, we produce your parts with tight tolerances. Our process is optimized for medical-grade materials and clean handling.',
  icon: BoxIcon
}, {
  id: 4,
  title: 'Quality Assurance',
  description: 'Every batch undergoes rigorous inspection. From dimensional analysis to visual checks, we ensure every cap and component meets your exact specifications before shipping.',
  icon: Microscope
}];
export function ProcessSteps() {
  return <section id="process" className="py-20 bg-white" data-id="element-367">
      <div className="container mx-auto px-4 md:px-6" data-id="element-368">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-369">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-370">
            From Concept to Component
          </h2>
          <p className="text-lg text-gray-600" data-id="element-371">
            We believe in transparency. Here is how we transform your
            requirements into precision-engineered parts, every single time.
          </p>
        </div>

        <div className="relative" data-id="element-372">
          {/* Connecting Line (Desktop) */}
          <div className="hidden md:block absolute top-12 left-0 right-0 h-0.5 bg-gray-100 -z-10" data-id="element-373" />

          <div className="grid grid-cols-1 md:grid-cols-4 gap-8" data-id="element-374">
            {steps.map((step, index) => <motion.div key={step.id} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} className="relative bg-white pt-4 md:pt-0" data-id="element-375">
                <div className="flex flex-col items-center text-center" data-id="element-376">
                  <div className="w-24 h-24 rounded-full bg-white border-4 border-blue-50 flex items-center justify-center mb-6 shadow-sm relative z-10" data-id="element-377">
                    <step.icon className="h-10 w-10 text-primary" data-id="element-378" />
                    <div className="absolute -top-2 -right-2 w-8 h-8 rounded-full bg-accent text-white flex items-center justify-center font-bold text-sm border-2 border-white" data-id="element-379">
                      {step.id}
                    </div>
                  </div>

                  <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-380">
                    {step.title}
                  </h3>
                  <p className="text-gray-600 leading-relaxed text-sm" data-id="element-381">
                    {step.description}
                  </p>
                </div>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}